/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
import { LTI1p1ProviderData } from './LTI1p1ProviderData';
import { LTI1p3ProviderData } from './LTI1p3ProviderData';
const CreateLTIDataParser = 
/* #__PURE__ */ /* #__PURE__ */ parsers.taggedUnion('ltiVersion', [
    ['lti1.1', LTI1p1ProviderData],
    ['lti1.3', LTI1p3ProviderData],
], 'lti_version');
export const CreateLTIData = CreateLTIDataParser;
